import moment from 'moment'
import { COMM_TEMPLATE, componentNames } from './constants'
import {
  FORMAT_PATTERN,
  formatPhoneNumber,
  formatValueWithPattern,
} from '@ui-kit'
import { convertTo12HourFormat } from './time'
import { RecipientFaxOutbound } from '@app-store'

export const formatZipCode = (input?: string | null) => {
  if (!input) return ''
  return formatValueWithPattern(input, FORMAT_PATTERN.ZIP_CODE)
}

export const stripZipCodeFormatting = (input?: string | null) => {
  if (!input) return ''
  return input.replace(/\D/g, '')
}

export const formatValueBasedOnControlType = (
  val: string | number,
  control_type: string
): string | number => {
  switch (control_type) {
    case componentNames.TIME:
      return convertTo12HourFormat(val as string)

    case componentNames.DATE_TIME:
      return moment(val as string)?.format('MM/DD/YYYY HH:mm A')

    case componentNames.DATE:
      return moment(val as string)?.format('MM/DD/YYYY')

    case componentNames.PHONE_NUMBER:
      return formatPhoneNumber(val as string, FORMAT_PATTERN.PHONE_INPUT)

    case componentNames.ZIP_CODE:
      return formatZipCode(val as string)

    default:
      return val
  }
}

export const buildMailingAddress = (
  item: RecipientFaxOutbound
): string | null => {
  const parts = [
    item.address_line_1,
    item.address_line_2,
    item.city,
    item?.state?.name,
    formatZipCode(item?.zip_code),
  ].filter(Boolean)

  if (parts.length === 0) return null

  const address = parts.join(', ')
  return item.is_preferred ? `${address} ${COMM_TEMPLATE.PRIMARY}` : address
}
